import { useState } from "react";
import instance, { url } from "../axios/instance";
import { toast } from "react-toastify";
import { getToken, saveToken } from "../utils/token";
import { ArrowRightLeft, ChevronDown } from "lucide-react";

function FacilitySelector({ facilities, facility, isMenuOpen }) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const newFacilities = [
    facility,
    ...facilities.filter((_fac) => _fac.id !== facility.id),
  ];

  const handleSwitchFacility = async (_facility) => {
    setLoading(true);
    try {
      const token = getToken();
      const res = await instance.post(
        "/doctor/switch-facility",
        {
          facilityId: _facility.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      saveToken(res.data.ACCESS_TOKEN);
      // localStorage.setItem("facility", _facility.id);
      // localStorage.setItem("facilityType", _facility.type);
      toast.success("Switch initialized. Reloading...");
      const type = _facility.type === "distributor" ? "distributor" : "clinic";
      window.location.href = `/${type}/dashboard/orders`;
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response ? error.response.data.message : "Something went wrong"
      );
    }
  };

  return (
    <>
      <div className="w-full">
        <button
          className={`bg-white w-full h-12 hover:border-primary  duration-300 cursor-pointer border flex justify-center gap-x-2 items-center rounded-md disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-[#eee] px-4 text-sm`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <ArrowRightLeft size="20" color="#FF8A65" />
          {isMenuOpen && (
            <div className="flex items-center gap-x-1">
              {facility.name}
            <span className="text-xs text-gray-500">
                ({facility.type === "distributor" ? "distributor" : "clinic"})
              </span>
            </div>
          )}
        </button>
        {isOpen && (
          <div className="absolute left-0 right-0 bottom-full w-full border border-b-0 border-gray-200 rounded-t-lg min-h-fit bg-white z-40">
            {newFacilities.map((_facility) => (
              <div
                key={_facility.id}
                className={`${
                  _facility.id === facility.id
                    ? "text-primary"
                    : "text-gray-700"
                } cursor-pointer px-4 py-4 border-b border-gray-200 hover:bg-gray-50 rounded-t-lg`}
                onClick={() => handleSwitchFacility(_facility)}
              >
                <h2 className=" text-sm font-medium">
                  {_facility.name}
                  <span className="text-gray-500 text-xs font-normal">
                    (
                    {_facility.type === "distributor"
                      ? "distributor"
                      : "clinic"}
                    )
                  </span>
                </h2>
              </div>
            ))}
          </div>
        )}
        {isOpen && (
          <div
            className="fixed top-0 right-0 left-0 w-full h-full bg-black opacity-[0.01] z-10"
            onClick={() => setIsOpen(false)}
          />
        )}
      </div>
      {loading && (
        <div className="fixed top-0 right-0 left-0 w-full h-full bg-black opacity-[0.5] z-50">
          <div className="flex items-center justify-center h-full">
            <div className="bg-white rounded-full p-2">
              <div className="w-10 h-10 border-t-transparent border-b-transparent border-r-transparent border-l-primary rounded-full animate-spin border-4"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FacilitySelector;
